import React from "react";
import MimicDiagram from "../components/MimicDiagram"; // bir sonraki adımda oluşturacağız

export default function MimicPage() {
  return (
    <div className="p-6">
      <MimicDiagram />
    </div>
  );
}
